import React from 'react';
import { Form, Button, Alert } from 'react-bootstrap';

import Link from '../../../../components/Link/Link';

import {
  RequestDemo,
  FORGOT_PASSWORD,
  RESET_PASSED,
  RESET_FAILED,
  EXPIRED_TOKEN,
} from '../../../../common/i18n';
import GreenTickIcon from '../../../../images/green-tick.png';

import './style.scss';

class LoginComponent extends React.PureComponent<Props, State> {
  render() {
    const {
      passwordResetStatus,
      history,
      user,
      fetching,
      error,
      isEmailValid,
      requestInvitationEmail,
      isInvitationEmailValid,
      showRequestEmailSection,
      invitationSubmitSuccess,
      handleSubmit,
      handleInvitationRequest,
      onLoginFieldsInput,
      validateEmail,
      setParentState,
    } = this.props;

    const loginInputFieldClass = isEmailValid ? '' : 'login-error-input-field';

    const enableInvitationButton = requestInvitationEmail.length > 0 && isInvitationEmailValid;

    return(
      <>
        {error && (<Alert variant="danger">
          <span className="icon-error"></span>&nbsp;&nbsp;<b>Oops!</b> you entered invalid credentials
        </Alert>)}
        {
          !error && passwordResetStatus === RESET_PASSED && (
            <div className="password-reset-suucess">
              <img className="green-tick-icon" src={GreenTickIcon} alt="green-tick-icon" />
                &nbsp;&nbsp;Password reset successfully.
            </div>
          )
        }
        {
          !error && passwordResetStatus === RESET_FAILED && (<Alert variant="danger">
            <span className="icon-error"></span>&nbsp;&nbsp;{EXPIRED_TOKEN}
          </Alert>)
        }
        <div className="login-heading">
          <h1>Sign In</h1>
        </div>
        <Form className="login-form-wrapper">
          <Form.Group controlId="formBasicEmail">
            <Form.Label>Email</Form.Label>
            <Form.Control
              className={loginInputFieldClass}
              required
              type="email"
              name="email"
              placeholder="Enter Your Email"
              value={user.email}
              onChange={onLoginFieldsInput}
              onBlur={validateEmail}/>

            {!isEmailValid && <span className="login-email-error">Invalid email</span>}
          </Form.Group>

          <Form.Group controlId="formBasicPassword">
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="password"
              name="password"
              placeholder="Enter Password"
              value={user.password}
              onChange={onLoginFieldsInput} />
          </Form.Group>

          <Link
            variant='primary-link'
            onClick={() => history.push('/forgot-password')}
          >
            {FORGOT_PASSWORD}
          </Link>

          <Button
            variant="primary"
            type="submit"
            block
            onClick={handleSubmit}
            className="login-btn"
            disabled={!isEmailValid || fetching}>
            {fetching ? 'Loading…' : 'Sign In'}
          </Button>
        </Form>
        {!invitationSubmitSuccess &&
          <Form className="request-invitation-wrapper">
            <Form.Group controlId="formInvitationEmail">
              <Form.Label
                onClick={() => setParentState('showRequestEmailSection', !showRequestEmailSection)}
              >
                <span className="request-invitation-wrapper-noaccount">
                  Don't have an account?
                </span>
                <span className="request-invitation-wrapper-demo">
                  {RequestDemo}
                </span>
                <span className="icon-dropdown-arrow"></span>
              </Form.Label>
              {showRequestEmailSection &&
                <Form.Control
                  className={loginInputFieldClass}
                  required
                  type="email"
                  name="requestEmail"
                  placeholder="Enter Email"
                  value={requestInvitationEmail}
                  onChange={(event) => {
                    setParentState('requestInvitationEmail', event.target.value);
                    validateEmail(event);
                  }}
                />
              }
            </Form.Group>
            {showRequestEmailSection &&
              <Button
                className={`request-invt-button-${
                  enableInvitationButton ? 'active' : 'inactive'
                }`}
                type="submit"
                block
                onClick={enableInvitationButton ? handleInvitationRequest : () => null}
                disabled={!isInvitationEmailValid}
              >
                Request Invitation
              </Button>
            }
          </Form>
        }
        {invitationSubmitSuccess && (
          <div className="request-submit-status">
            <div className="request-submit-status-success">
              <img className="green-tick-icon" src={GreenTickIcon} alt="green-tick-icon" />
              <span className="green-tick-icon-text">Thank you, we will be in touch shortly.</span>
            </div>
            <div className="request-submit-status-text">We will send your invitation to {requestInvitationEmail}</div>
          </div>
        )}
      </>
    );
  }
}

export default LoginComponent;
